import './index.scss'
import React from 'react'
import { connect } from 'react-redux'
import Layer from '../layer'

class LayerTree extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      expandedNodes: []
    }
    this.makeNode = this.makeNode.bind(this)
    this.makeLayers = this.makeLayers.bind(this)
    this.containerRef = React.createRef()
  }

  makeLayers(layers, onlyProductionLayers) {
    let filterProdLayers = () => {
      if (onlyProductionLayers) {
        return layers.filter((item) => {
          return item.production && item
        })
      }
      else {
        return layers
      }
    }
    let finalLayers = filterProdLayers()
    const activeSettings = this.props.userSettings.find(setting => setting.settingId === 1)
    return finalLayers.map(layer => <Layer layer={layer} key={`layer-${layer.id}`} settingId={1}
      active={activeSettings.valueArray.some(id => id === layer.id)}></Layer>)
  }

  makeNode(node) {
    const { expandedNodes } = this.state,
      clone = [].concat(expandedNodes)
    const { productionLayers } = this.props
    const domain = process.env.NODE_ENV === 'production'
    const layerStyle = {
      position: 'relative',
      height: '40px',
      width: 290
    }
    return (
      <div className='layer-node'
        key={`node-${node.id}`}
        onClick={(e) => {
          e.stopPropagation()
          const idx = expandedNodes.indexOf(node.id)
          if (idx === -1) {
            clone.push(node.id)
            this.setState({ expandedNodes: clone })
          } else {
            clone.splice(idx, 1)
            this.setState({ expandedNodes: clone })
          }
        }}>
        <div style={{
          ...layerStyle, display: 'flex',
          alignItems: 'center',
        }}>
          <div className='responsive-layer-icon' style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{
              width: 25,
              height: 25,
              border: '2px solid #959595',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'

            }}> <p className='layer-icon-plus-minus'>{expandedNodes.indexOf(node.id) !== -1 ? '-' : '+'}</p></div>
          </div>
          {node && node.iconUrl && node.iconUrl &&
            <div style={{
              width: '50px'
            }}>
              <img src={node.iconUrl} style={{ width: 30, height: 30 }}></img>
            </div>}
          <div className='responsive-layer-node' >
            <h3 className='species-layer-node-title' title={node.name}>
              {node.name}
            </h3>
          </div>

        </div>
        {expandedNodes.indexOf(node.id) !== -1 ? (
          <>
            <div className='layer-node-layer-container'>
              {node.layerNodes.map(nested => {
                if (productionLayers) {
                  return nested.production && this.makeNode(nested)
                } else if (domain) {
                  return nested.production && this.makeNode(nested)
                }
                return this.makeNode(nested)
              }
              )}
            </div>
            <div className='layer-node-layer-container-two' >
              {this.makeLayers(node.layers, this.props.productionLayers)}
            </div>
          </>
        ) : null}
      </div>
    )
  }

  render() {
    const { layers, productionLayers } = this.props,
      style = {}
    const domain = process.env.NODE_ENV === 'production'
    if (!layers.layerNodes) {
      return null
    }
    if (this.containerRef.current !== null) {
      const bounds = this.containerRef.current.getBoundingClientRect()
      style.height = `calc(100vh - ${bounds.top - 5}px)`
    }
    return (
      <div className='layer-tree-container' ref={this.containerRef}
        style={style}
      >
        {layers.layerNodes.map(node => {
          if (!node.enabled) {
            return null
          } else if (productionLayers) {
            return node.production && this.makeNode(node)
          } else if (domain) {
            return node.production && this.makeNode(node)
          }
          return this.makeNode(node)
        })}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  layers: state.layers,
  userSettings: state.userSettings,
  productionLayers: state.productionLayers
})

const mapDispatchToProps = state => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(LayerTree)